/**
 * Created by jonas on 2022-01-11.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {KitchenDramaSushiManiaTextStyles} from "../config/KitchenDramaSushiManiaTextStyles";
import {RadialText} from "../components/RadialText";
import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {SymbolTransformAnimation} from "./subviews/SymbolTransformAnimation";
import {KitchenDramaStrings} from "../config/KitchenDramaStrings";
import {DevKeyTriggerManager} from "@nolimitcity/slot-launcher/bin/devtools/DevKeyTriggerManager";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";


export class TransitionScreenView extends PIXI.Container implements StageLayer {
    protected button:ContinueButton;
    private clickCallback:Function | undefined;
    public text:PIXI.Text;
    private _introText:PIXI.Text;
    private _background:PIXI.Sprite;
    private _bannerBg:PIXI.Sprite;
    private _bannerPattern:PIXI.Sprite;
    private _outroDecoration:PIXI.Sprite;
    private _logoText:RadialText;
    private _chopSticksDecor:PIXI.Sprite;
    private _symbolTransformAnimation:SymbolTransformAnimation;
    private _coverPlate:PIXI.Sprite;
    private _banner:PIXI.Container;
    private _bannerLeftAnimation:TimelineSprite;
    private _bannerRightAnimation:TimelineSprite;
    private _fsNumberAnimation:TimelineSprite;
    private _youWonText:RadialText;
    private _youWonText2:PIXI.Text;
    private _freeSpinsText:RadialText;
    private _genericTextTimeline:gsap.core.Timeline;
    private _genericBackground:PIXI.Sprite;
    private _genericContainer:PIXI.Container;
    private _sushiContainer:PIXI.Container;


    constructor() {
        super();
        this.name = "TransitionScreenView";
        this.init();
    }

    protected init() {

        this._genericBackground = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._genericBackground.tint = PIXI.utils.string2hex("#15181D");
        this._genericBackground.anchor.set(0.5,0.5);

        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = PIXI.utils.string2hex("#7d5599");

        this._coverPlate = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._coverPlate.tint = PIXI.utils.string2hex("#19151e");
        this._coverPlate.alpha = 0;
        this._coverPlate.name = "coverPlate";

        this._bannerBg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bannerBg.tint = PIXI.utils.string2hex("#614079");
        this._bannerBg.height = 196;
        this._bannerBg.anchor.set(0.5,0.5);
        this._bannerBg.position.set(360,310);

        this._bannerPattern = new PIXI.TilingSprite(ImgLoader.getImgTexture("sushiBannerTexture"));
        this._bannerPattern.height = 180;
        this._bannerPattern.anchor.set(0.5,0.5);
        this._bannerPattern.position.set(360,310);


        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());

        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this._introText = new PIXI.Text("Extra Sushi Wilds rewarded from wins on sushi ingredients.", KitchenDramaSushiManiaTextStyles.FREESPIN_INTRO_INFORMATION);
        this._introText.anchor.set(0.5, 0);
        this._introText.position.set(360, 410);
        this._introText.alpha = 0;

        this._outroDecoration = new PIXI.Sprite(ImgLoader.getImgTexture("sushi_outro-decor"));
        this._outroDecoration.anchor.set(0.5, 0);
        this._outroDecoration.position.set(360, 410);

        this._chopSticksDecor  = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.CHOP_STICKS_DECOR)[0]);
        this._chopSticksDecor.anchor.set(0,0.5);
        this._chopSticksDecor.position.set(340,100);
        this._chopSticksDecor.scale.set(0.75,0.75);

        this._logoText = new RadialText("WILD SUSHI", 1000, -1, KitchenDramaSushiManiaTextStyles.WILD_SUSHI_LOGO);
        this._logoText.position.set(360, 100);
        this._logoText.anchor.set(0.5, 0.5);

        this._symbolTransformAnimation = new SymbolTransformAnimation();
        this._symbolTransformAnimation.position.set(360,396);

        this._youWonText2 = new PIXI.Text(KitchenDramaSushiMania.apiPlugin.translations.translate(KitchenDramaStrings.TEXT_YOU_WON_UPPER_CASE), KitchenDramaSushiManiaTextStyles.KEY_FS_INTRO_YOU_WON_STYLE);
        this._youWonText2.position.set(360,260);
        this._youWonText2.anchor.set(0.5, 0.5);

        this._genericContainer = new PIXI.Container();
        this._genericContainer.addChild(this._genericBackground);
        this._genericContainer.addChild(this.createGenericIntroGraphics());
        this._genericContainer.position.set(360,360);

        this._sushiContainer = new PIXI.Container();
        this._sushiContainer.name = "_sushiContainer";

        this._sushiContainer.addChild(this._background);
        this._sushiContainer.addChild(this._bannerBg);
        this._sushiContainer.addChild(this._bannerPattern);
        this._sushiContainer.addChild(this._chopSticksDecor);
        this._sushiContainer.addChild(this._logoText);
        this._sushiContainer.addChild(this._symbolTransformAnimation);
        this._sushiContainer.addChild(this._introText);
        this._sushiContainer.addChild(this._outroDecoration);
        this._sushiContainer.addChild(this._youWonText2);
        this._sushiContainer.addChild(this.button);
        this._sushiContainer.visible  = false;

        this.addChild(this._genericContainer);
        this.addChild(this._sushiContainer);

        this.addChild(this._coverPlate);



        this.visible = false;

    }

    private createGenericIntroGraphics():PIXI.Container {

        this._banner = new PIXI.Container();
        const back = new PIXI.Sprite(PIXI.Texture.WHITE);
        back.tint = PIXI.utils.string2hex("#7d539b");
        back.height = 298;
        back.anchor.set(0.5,0.5);
        const front = new PIXI.Sprite(PIXI.Texture.WHITE);
        front.tint = PIXI.utils.string2hex("#332645");
        front.height = 282;
        front.anchor.set(0.5,0.5);
        this._banner.addChild(back, front);

        this._bannerLeftAnimation = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.BANNER_LEFT));
        this._bannerLeftAnimation.anchor.set(0, 0.5);
        this._bannerLeftAnimation.x = -730;
        this._bannerLeftAnimation.y = this._banner.y;


        this._bannerRightAnimation = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.BANNER_RIGHT));
        this._bannerRightAnimation.anchor.set(1, 0.5);
        this._bannerRightAnimation.x = 730;
        this._bannerRightAnimation.y = this._banner.y;

        this._bannerLeftAnimation.hide();
        this._bannerRightAnimation.hide();


        //Generic splash text

        const split = KitchenDramaSushiMania.apiPlugin.translations.language === "hi" ? " " : "";

        this._youWonText = new RadialText(KitchenDramaSushiMania.apiPlugin.translations.translate(KitchenDramaStrings.TEXT_YOU_WON_UPPER_CASE), 1000, -1, KitchenDramaSushiManiaTextStyles.KEY_FS_INTRO_YOU_WON_STYLE, undefined, split);
        this._youWonText.position.set(0, -150);
        this._youWonText.anchor.set(0.5, 0.5);

        this._freeSpinsText = new RadialText(KitchenDramaSushiMania.apiPlugin.translations.translate(KitchenDramaStrings.FREE_SPINS), -1000, 1, KitchenDramaSushiManiaTextStyles.KEY_FS_INTRO_YOU_WON_STYLE);
        this._freeSpinsText.position.set(0, 150);
        this._freeSpinsText.anchor.set(0.5, 0.5);

        this._introText = new PIXI.Text(KitchenDramaSushiMania.apiPlugin.translations.translate(KitchenDramaStrings.TEXT_INFO_SUSHI), KitchenDramaSushiManiaTextStyles.FREESPIN_INTRO_INFORMATION);
        this._introText.anchor.set(0.5, 0);
        this._introText.position.set(360, 410);
        this._introText.alpha = 0;

        this._genericTextTimeline = this.createGenericIntroTextAnimation();

        this._fsNumberAnimation = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.FS_NUMBER_ANIM));
        this._fsNumberAnimation.anchor.set(0.5, 0.5);
        this._fsNumberAnimation.scale.set(0.9);
        this._fsNumberAnimation.position.set(0, -15);
        this._fsNumberAnimation.hide();


        const container = new PIXI.Container();

        container.addChild(this._banner);
        container.addChild(this._bannerLeftAnimation);
        container.addChild(this._bannerRightAnimation);
        container.addChild(this._freeSpinsText);
        container.addChild(this._youWonText);
        container.addChild(this._fsNumberAnimation);

        return container;
    }

    private createGenericIntroTextAnimation():gsap.core.Timeline {
        const tl = gsap.timeline({paused:true});
        let chars = this._youWonText.getCharacters("");
        chars = chars.concat(this._freeSpinsText.getCharacters(""));
        for(let i:number = 0; i < chars.length; i++) {
            let char:PIXI.Text = chars[i];
            char.scale.set(0, 0);
            let charTimeline = gsap.timeline();
            charTimeline.add(gsap.to(char.scale, {duration:0.1, x : 1.3, y : 1.3, ease : "power1.out"}));
            charTimeline.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOL_LANDING));
            charTimeline.add(gsap.to(char.scale, {duration:0.3, x : 1.0, y : 1.0, ease : "power1.in"}));

            tl.add(charTimeline, i * 0.07);
        }
        return tl;
    }

    public resetTexts(){
        let chars = this._youWonText.getCharacters(" ");
        chars = chars.concat(this._freeSpinsText.getCharacters(" "));
        chars = chars.concat(this._logoText.getCharacters(" "));
        for(let i:number = 0; i < chars.length; i++) {
            let char:PIXI.Text = chars[i];
            char.scale.set(0, 0);
        }
    }

    public setup(intro:boolean) {
        if (intro){
            this.resetTexts();
            this._bannerLeftAnimation.x = -730;
            this._bannerRightAnimation.x = 730;
            this._bannerLeftAnimation.hide();
            this._bannerRightAnimation.hide();

            this._outroDecoration.visible = false;
            this._sushiContainer.visible = false;

            this._introText.visible = true;
            this._symbolTransformAnimation.reset();
            this._symbolTransformAnimation.visible = true;
            this._youWonText2.visible=false;
            this._genericContainer.visible = true;
            this._genericBackground.alpha = 0;
            this._banner.scale.y = 0;

        } else {
            const isBelowWinRestriction= KitchenDramaSushiMania.isWinBelowStake(KitchenDramaSushiMania.model.gameData.totalRoundWin);
            this._outroDecoration.visible = true;
            this._sushiContainer.visible = true;

            this._introText.visible = false;
            this._symbolTransformAnimation.visible = false;
            this._youWonText2.visible = !isBelowWinRestriction
            this._genericContainer.visible = false;
            this._genericBackground.alpha = 0;
            this._banner.scale.y = 0;
        }
    }


    onResize():void {
        if(NolimitApplication.isLandscape) {
            this.button.position.set(360, 610);
        }
        else {
            this.button.position.set(360, NolimitApplication.screenBounds.bottom - 170);
        }

        this._bannerBg.width = NolimitApplication.screenBounds.width;
        this._bannerPattern.width = NolimitApplication.screenBounds.width;


        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.position.set(
            NolimitApplication.screenBounds.left,
            NolimitApplication.screenBounds.top
        );

        this._genericBackground.width = NolimitApplication.screenBounds.width;
        this._genericBackground.height = NolimitApplication.screenBounds.height;

        this._coverPlate.width = NolimitApplication.screenBounds.width;
        this._coverPlate.height = NolimitApplication.screenBounds.height;
        this._coverPlate.position.set(
            NolimitApplication.screenBounds.left,
            NolimitApplication.screenBounds.top
        )

        this._banner.width = NolimitApplication.screenBounds.width;

    }

    private onButtonClick() {
        this.button.enable(false);
        if(this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.CONTINUE_BUTTON);
        gsap.to(this.button, {duration : 0.2, alpha : 0});
        delete this.clickCallback;
    }

    public enableButton(cb:Function):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration : 0.2, alpha : 1}));
        return tl;
    }

    public show(duration:number, intro:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.alpha = 0;
            this.setup(intro);
            this.onResize();
            this.visible = true;
        });

        tl.add(gsap.to(this, {duration : duration, alpha : 1, ease : "none"}));

        return tl;
    }

    public hide(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this, {duration : duration, alpha : 0, ease : "none"}));

        tl.add(() => {
            this.visible = false;
        });

        return tl;
    }


    public getLogoAnimation():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=>{
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.WILD_SUSHI_TEXT_SOUND);
        })
        const sushiHeadChars = this._logoText.getCharacters(" ");
        for(let i:number = 0; i < sushiHeadChars.length; i++) {
            let char:PIXI.Text = sushiHeadChars[i];
            char.scale.set(0, 0);
            let charTimeline = gsap.timeline();
            charTimeline.add(gsap.to(char.scale, {duration:0.1, x : 1.3, y : 1.3, ease : "power1.out"}));
            charTimeline.add(gsap.to(char.scale, {duration:0.3, x : 1.0, y : 1.0, ease : "power1.in"}));

            tl.add(charTimeline, i * 0.1);
        }

        return tl;
    }

    public showInfoText(duration:number = 0.5):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this._introText, {duration:duration, alpha:1}))
        return tl;
    }

    getJumpAnimation() {
        return this._symbolTransformAnimation.getJumpAnimation();
    }

    getTransformAnimation() {
        return this._symbolTransformAnimation.getTransformAnimation();
    }


    addCoverPlate(duration:number){
        const tl = gsap.timeline();
        tl.add(gsap.to(this._coverPlate, {duration:duration, alpha:1}));
        return tl;
    }

    removeCoverPlate(duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=>{
            this._sushiContainer.visible = true;
        })
        tl.add(gsap.to(this._coverPlate, {duration:duration, alpha:0}));
        return tl;

    }

    public getOutro():gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(()=>{this._sushiContainer.visible = false;});
        tl.add(() => {
            KitchenDramaSushiMania.soundPlayer.fadeOutMusic(1500,0);
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_END_SOUND);
        });
        tl.add(this.addCoverPlate(0.5),2);
        tl.add(this.removeCoverPlate(0.5),"+=0.5");

        return tl;
    }


    public getPreIntro():gsap.core.Timeline {
        const tl = gsap.timeline();
        let defaultEase = "power1.out";

        //back plate fade in
        tl.add([
            ()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_SPLASH_START),
            ()=>KitchenDramaSushiMania.soundPlayer.fadeOutMusic(200),
            gsap.to(this._genericBackground, {duration:0.8, alpha : 0.7, ease : defaultEase})
        ]);

        //banner in
        tl.add([
            gsap.to(this._banner.scale, 0.3, {y : 1, ease : defaultEase})
        ], "+=0.1");


        tl.add([
            ()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_SPLASH_START_MELODY),
            () => this._bannerLeftAnimation.show(),
            () => this._bannerRightAnimation.show()
        ]);
        tl.add([
            this._bannerLeftAnimation.getAnimation(),
            this._bannerRightAnimation.getAnimation(),
            this._genericTextTimeline.play()
        ]);
        tl.add(() => this._fsNumberAnimation.show());
        tl.add(this._fsNumberAnimation.getAnimation());
        tl.add(()=>{KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_SPLASH_NUMBER)}, "-=0.3");

        //banner out
        tl.add(gsap.to(this._coverPlate, 1.0, {alpha : 1}), "+=1.0");

        tl.add(() => this._fsNumberAnimation.hide());
        tl.add(()=>{this._genericContainer.visible = false;});


        return tl;
    }


}